/**
 * interfaces
 */
import { IUnitDetailsModel } from './interfaces';
import { IUnitDetailsDto } from '../../interfaces';

/**
 * base model
 */
import { UnitModel } from '../unit-model';

/**
 * View model for a full unit detail response (GET units/{id}).
 *
 * Extends {@link UnitModel} — all first-level getters and {@link hasChildrenBadge}
 * are inherited. This class only adds the extra fields returned by the
 * by-id endpoint: {@link parentId} and {@link createdBy}.
 *
 * Each model declares its own named DTO (`unitDetailsDto`) for clear,
 * type-safe access to its shape-specific fields.
 *
 * @example
 * ```ts
 * const model = new UnitDetailsModel(dto);
 * console.log(model.name);                        // "Zone 01"  (base getter)
 * console.log(model.unitDetailsDto.parent_id);    // "abc-123"  (own DTO)
 * console.log(model.parentId);                    // "abc-123"  (own getter)
 * ```
 */
export class UnitDetailsModel extends UnitModel<IUnitDetailsDto> implements IUnitDetailsModel<IUnitDetailsDto> {

    /**
     * @param unitDetailsDto - Raw full unit detail DTO from the GET by-id endpoint.
     */
    constructor(dto: IUnitDetailsDto) {
        super(dto);
    }

    // ─── IUnitDetailsDto-specific getters ─────────────────────────────────────

    /**
     * ID of the parent unit, or null for root-level units.
     */
    public get parentId(): string | null {
        return this.dto.parent_id;
    }

    /**
     * ID of the user who created this unit, or null.
     */
    public get createdBy(): string | null {
        return this.dto.created_by ?? null;
    }

}
